import { $Q } from './query-selector'
import { stringToHTML } from './to-html';
import api from '../services/api';

/**
 * Update the width of bar progress
 * @param {DOM element} input - input hidde with data
 */
export const barProgress = () => {
  const input = $Q('.progress-bar-data');
  
  if(!input) return;

  const totalPrice = parseFloat(input.dataset.total) / 100;
  const limitPrice = parseInt(input.dataset.limit);
  const progress = $Q('.bar-progress');
  const textElement = $Q('.progress-bar__text');

  if (!progress) return null;

  let barWidth = 0;

  if (input.dataset.freeShipping === 'true') {
    barWidth = 100;

    if (textElement && input.dataset.titleFinish) {
      textElement.textContent = input.dataset.titleFinish;
    }
  } else {
    barWidth = totalPrice / limitPrice * 100;
  }

  if (barWidth > 100) {
    progress.style.width = "100%";
  } else {
    progress.style.width = `${barWidth}%`;
  }
}

export const updateBarProgress = (str) => {
  const updateContent = $Q(".progress-bar__container", stringToHTML(str)); 

  const input = updateContent.querySelector('.progress-bar-data');

  if(!input) return;

  // Check if free shipping was already set before updating
  const currentContainer = $Q(".progress-bar__container");
  const currentInput = currentContainer?.querySelector('.progress-bar-data');
  const wasFreeShipping = currentInput?.dataset.freeShipping === 'true';

  const totalPrice = parseFloat(input.dataset.total) / 100;
  const limitPrice = parseInt(input.dataset.limit);
  const progress = updateContent.querySelector('.bar-progress');
  const textElement = updateContent.querySelector('.progress-bar__text');

  if (!progress) return null;

  let barWidth = 0;

  // Preserve free shipping state if it was set, or check the new input
  if (wasFreeShipping || input.dataset.freeShipping === 'true') {
    barWidth = 100;
    // Ensure the attribute is set in the new HTML
    input.setAttribute('data-free-shipping', 'true');
    // Update text to final text if available
    if (textElement && input.dataset.titleFinish) {
      textElement.textContent = input.dataset.titleFinish;
    }
  } else {
    barWidth = totalPrice / limitPrice * 100;
  }

  if (barWidth > 100) {
    progress.style.width = "100%";
  } else {
    progress.style.width = `${barWidth}%`;
  }

  $Q(".progress-bar__container").innerHTML = updateContent.outerHTML;
};

export const setFreeShipping = () => {
  try {
    const progressBar = $Q(".progress-bar__container")
    const barInput = $Q('#progress-bar-data', progressBar);
    barInput.setAttribute('data-free-shipping', 'true');
    barProgress();
  } catch(error) {
    console.error('Error on setting of free shipping', error);
  }
  
}

/**
 * Check if there are shipping discount codes in the cart and set free shipping if found
 * This is called on page load to preserve free shipping state after reload
 */
export const checkShippingCodesOnLoad = async () => {
  try {
    const cartData = await api.getCart();
    if (!cartData?.discount_codes || cartData.discount_codes.length === 0) {
      return;
    }

    // Check each discount code to see if it's a shipping code
    for (const discountCode of cartData.discount_codes) {
      if (!discountCode.code) continue;

      try {
        const codeData = await api.getGiftCodeData(discountCode.code);
        if (codeData?.discount?.discountClasses?.includes('SHIPPING') && !codeData.giftProductId) {
          setFreeShipping();
          break;
        }
      } catch (error) {
        // If we can't get code data, skip it
        console.warn(`Could not check discount code ${discountCode.code}:`, error);
        continue;
      }
    }
  } catch (error) {
    console.error('Error checking shipping codes on load:', error);
  }
}
